export default "__VITE_ASSET__a71286e7__"